export default "__VITE_ASSET__DFrxt9wt__"